"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'share.conversation.loading': 'Cargando conversación...',
    'share.conversation.noIdProvided': 'No se proporcionó ID de conversación',
    'share.conversation.failedToLoad': 'No se pudo cargar la conversación',
    'share.conversation.untitled': 'Conversación sin título',
    'share.conversation.linkCopied': 'Enlace copiado al portapapeles',
    'share.conversation.linkCopyFailed': 'No se pudo copiar el enlace',
    'share.conversation.copyLink': 'Copiar enlace',
    'share.conversation.goToChat': 'Ir al chat',
    'share.conversation.you': 'Tú',
    'share.conversation.assistant': 'Asistente',
    'share.conversation.reasoning': 'Razonamiento',
    'share.conversation.thoughts': 'Pensamientos',
    'share.conversation.sources': 'Fuentes',
    'share.conversation.toolsUsed': 'Herramientas utilizadas',
    'share.conversation.noMessages': 'No se encontraron mensajes',
    'share.conversation.noMessagesDescription': 'Esta conversación parece estar vacía o no se pudieron cargar los mensajes.',
    'share.conversation.footerNote': 'Esta es una conversación compartida. Puedes iniciar tu propio chat para interactuar con la IA.',
    'share.conversation.startNewChat': 'Iniciar nuevo chat',
    'share.conversation.unknownModel': 'Modelo desconocido',
    'share.conversation.unknownFile': 'Archivo desconocido',
    'share.conversation.unknownSize': 'Tamaño desconocido',
};
